import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import {
  OrderLineStatusEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
export interface StoreOrderPickDialogProps extends DialogProps {
  orderId: string;
  variant: any;
  onSubmitOrderLineStatus: (lineIds: any, status: OrderLineStatusEnum) => void;
  editProductDialog: (data: { type: string; payload: any }) => void;
  orderStatus: any;
}

const useStyles = makeStyles(
  theme => ({
    buttonActionFlex: {
      flexDirection: "column"
    },
    buttonActions: {
      display: "flex",
      width: "100%"
    },
    buttonBack: {
      background: "#f9f9f9  !important",
      border: "1px solid #E5E5E5 !important",
      margin: "3px",
      width: "100%"
    },
    buttonBackLabel: {
      color: "#3D3D3D"
    },
    buttonLabelBlack: {
      color: "#3D3D3D"
    },
    buttonLabelWhite: {
      color: "white !important"
    },
    buttonOutOfStock: {
      color: "#E26139 !important"
    },
    buttonPicked: {
      "& span": {
        color: "#002972 !important"
      },
      alignContent: "center",
      background: "#FFD15C !important",
      marginLeft: "0px !important",
      width: "100%"
    },
    buttonPicking: {
      background: "#FFFFFF !important",
      border: "1px solid #A9A6A6  !important",
      margin: "5px",
      width: "100%"
    },
    containedGray: {
      backgroundColor: "#A1A1A1 !important",
      margin: "5px",
      marginLeft: "0px",
      width: "100%"
    },
    outlineOrange: {
      border: "1px solid #E26139 !important",
      margin: "5px",
      marginRight: "0px",
      width: "100%"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    textBold: {
      fontSize: "20px",
      fontWeight: 600,
      paddingLeft: "1em",
      textAlign: "left",

      width: "30%",
      [theme.breakpoints.down("md")]: {
        fontSize: "16px",
        paddingLeft: "0em",
        textAlign: "left"
      }
    },
    textRight: {
      fontSize: "20px",
      paddingLeft: "1em",
      textAlign: "left",
      [theme.breakpoints.down("md")]: {
        fontSize: "15px",
        paddingLeft: "0em"
      }
    }
  }),
  { name: "StoreOrderPickDialog" }
);

const StoreOrderPickDialog: React.FC<StoreOrderPickDialogProps> = props => {
  const {
    onClose,
    open,
    orderId: variantId,
    variant,
    onSubmitOrderLineStatus,
    editProductDialog,
    orderStatus
  } = props;
  const classes = useStyles(props);

  const checkStatusLabel = () => {
    switch (variant.status) {
      case "OUT_OF_STOCK":
        return <span>Out Of Stock</span>;
      case "PICKING":
        return <span>Picking</span>;
      case "PICKED":
        return <span>Picked</span>;
      default:
        break;
    }
  };

  const formatter = new Intl.NumberFormat("en-PH", {
    currency: "PHP",
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    style: "currency"
  });

  const formatCurrency = (price: string) => {
    const parsedPrice = parseFloat(price);
    return formatter.format(parsedPrice);
  };

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
      <>
        <DialogTitle>Product {variant.productName}</DialogTitle>
        <DialogContent>
          <table className={classes.root}>
            <tbody>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Variant"
                    description="order detail variant"
                  />
                </th>
                <td className={classes.textRight}>{variant.variantName}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="SKU Code"
                    description="order detail variant"
                  />
                </th>
                <td className={classes.textRight}>{variant?.variant?.sku}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Quantity"
                    description="order detail qantity"
                  />
                </th>
                <td className={classes.textRight}>{variant.quantity + "x"}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Price"
                    description="order detail price"
                  />
                </th>
                <td className={classes.textRight}>
                  {formatCurrency(variant.unitPrice.gross.amount)}
                </td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Total"
                    description="order detail total"
                  />
                </th>
                <td className={classes.textRight}>
                  {formatCurrency(variant.totalPrice.gross.amount)}
                </td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Status"
                    description="order detail status"
                  />
                </th>
                <td className={classes.textRight}>{checkStatusLabel()}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Note"
                    description="order detail note"
                  />
                </th>
                <td className={classes.textRight}>{variant.notes}</td>
              </tr>
            </tbody>
          </table>
        </DialogContent>

        {orderStatus === SmopOrderStatusEnum.ACKNOWLEDGED ? (
          <DialogActions className={classes.buttonActionFlex}>
            <div className={classes.buttonActions}>
              <Button
                disabled={variant.status === "PICKING" ? true : false}
                autoFocus
                onClick={() => {
                  onSubmitOrderLineStatus(
                    variantId,
                    OrderLineStatusEnum.PICKING
                  );
                  onClose();
                }}
                className={classNames({
                  [classes.containedGray]: variant.status === "PICKING",
                  [classes.buttonPicking]: variant.status !== "PICKING"
                })}
              >
                <span
                  className={classNames({
                    [classes.buttonLabelWhite]: variant.status === "PICKING",
                    [classes.buttonLabelBlack]: variant.status !== "PICKING"
                  })}
                >
                  PICKING
                </span>
              </Button>
              <Button
                disabled={variant.status === "OUT_OF_STOCK" ? true : false}
                onClick={() => {
                  editProductDialog({
                    payload: variantId,
                    type: "OUT_OF_STOCK"
                  });
                }}
                className={classNames({
                  [classes.containedGray]: variant.status === "OUT_OF_STOCK",
                  [classes.outlineOrange]: variant.status !== "OUT_OF_STOCK"
                })}
              >
                <span
                  className={classNames({
                    [classes.buttonLabelWhite]:
                      variant.status === "OUT_OF_STOCK",
                    [classes.buttonOutOfStock]:
                      variant.status !== "OUT_OF_STOCK"
                  })}
                >
                  OUT OF STOCK
                </span>
              </Button>
            </div>

            <Button
              disabled={variant.status === "PICKED" ? true : false}
              className={classNames({
                [classes.containedGray]: variant.status === "PICKED",
                [classes.buttonPicked]: variant.status !== "PICKED"
              })}
              color="primary"
              onClick={() => {
                onSubmitOrderLineStatus(variantId, OrderLineStatusEnum.PICKED);
                onClose();
              }}
            >
              <span className={classes.buttonLabelWhite}>PICKED</span>
            </Button>
          </DialogActions>
        ) : (
          <DialogActions className={classes.buttonActionFlex}>
            <Button
              onClick={onClose}
              variant="contained"
              color="default"
              className={classes.buttonBack}
            >
              <span className={classes.buttonBackLabel}>BACK</span>
            </Button>
          </DialogActions>
        )}
      </>
    </Dialog>
  );
};
StoreOrderPickDialog.displayName = "StoreOrderPickDialog";
export default StoreOrderPickDialog;
